.wrap {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.eyebrow {
  margin: 0;
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-accent);
  text-transform: uppercase;
}

.title {
  font-family: var(--font-display);
  font-size: clamp(1.5rem, 4vw, 2.25rem);
  letter-spacing: var(--letter-spacing-display);
  color: var(--color-fg);
  margin: 0;
}

.lede {
  font-family: var(--font-body);
  font-size: var(--font-size-body-lg);
  color: var(--color-fg-muted);
  margin: 0;
  max-width: 60ch;
}

/* PS2 memory-card chrome wrapping the project grid. */
.frame {
  display: flex;
  flex-direction: column;
  background: var(--color-bg-sunken);
  border: var(--border-width-2) var(--border-style) var(--color-fg-dim);
  box-shadow: var(--shadow-pixel-md);
}

.headerStrip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-4);
  background: var(--color-accent);
  color: var(--color-bg);
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  text-transform: uppercase;
  border-bottom: var(--border-width-2) var(--border-style) var(--color-fg-dim);
}

.headerStripLabel {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.headerStripCount {
  color: var(--color-bg);
  opacity: 0.85;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: var(--space-4);
  margin: 0;
  padding: var(--space-5);
  list-style: none;
}

.cell {
  display: flex;
}

.cell > * {
  width: 100%;
}

.footerHints {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: var(--space-5);
  padding: var(--space-2) var(--space-4);
  background: var(--color-bg);
  color: var(--color-fg-muted);
  font-family: var(--font-display);
  font-size: 0.625rem;
  letter-spacing: var(--letter-spacing-display);
  text-transform: uppercase;
  border-top: var(--border-width-2) var(--border-style) var(--color-fg-dim);
}

.empty {
  font-family: var(--font-body);
  color: var(--color-fg-muted);
  border: var(--border-width-2) var(--border-style) var(--color-fg-dim);
  padding: var(--space-5);
  text-align: center;
}
